import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("App")
const _hoisted_2 = {
  key: 0,
  class: "profile"
}
const _hoisted_3 = {
  key: 1,
  class: "profile"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Login ")

import { watch } from 'vue'
import { useRouter } from 'vue-router'
import { useLoading } from '@/composables'
import useLogout from '@/modules/core/auth/composables/useLogout'
import getUser from '@/modules/core/auth/composables/getUser'


export default /*#__PURE__*/_defineComponent({
  emits: ['handleDrawer'],
  setup(__props, { emit }) {

const { logout, isPending, notification } = useLogout()
const router = useRouter()
const { user } = getUser()
const { overlayLoading } = useLoading()
watch(
  () => isPending.value,
  (newValue) => {
    overlayLoading(newValue)
  }
)

// eslint-disable-next-line no-undef


const handleClick = async () => {
  await logout()
  if (!notification.value.error) router.push({ name: 'Welcome' })
}
const handleDrawer = () => {
  emit('handleDrawer')
}

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_btn = _resolveComponent("app-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    app: "",
    color: "primary",
    flat: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar_nav_icon, { onClick: handleDrawer }),
      _createVNode(_component_v_app_bar_title, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_v_spacer),
      (_unref(user))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_router_link, { to: { name: 'Profile' } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(user).displayName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_app_btn, {
              flat: "",
              icon: "mdi-logout",
              disabled: _unref(isPending),
              onClick: handleClick
            }, null, 8, ["disabled"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_router_link, { to: { name: 'Welcome' } }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }))
}
}

})